import * as api from '../api'
export default {
  methods: {
    //通过文章id获取文章操作日志
    getOperateLogs (id) {
      //获取操作日志
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                       // 必须字段： 文章参数
          "id_article": id,           // 必须字段： 文章 ID
        }
      }
      this.$store.dispatch('GET_OPERATELOG_DATA', option)
    },

    //获取审核日志
    getAuditLogs (id) {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                       // 必须字段： 参数
          "id_content": id,        // 必须字段：审核内容的 id（稿件 ID 或 视频 ID）
          "item_type": "article",    // 必须字段：类型  稿件为  article  视频为 material
          "page_no": 0,                      // 可选字段：分页参数，页号，从 0 开始
          "page_size": 1000                   // 可选字段：分页参数，每页长度，默认为 100
        }
      }
      this.$store.dispatch('GET_AUDIT_LOGLIST', option)

    },

    //获取评论列表
    getCommentList (id) {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                       // 必须字段： 文章参数
          "id_article": id          // 必须字段： 文章 ID
        }
      }
      this.$store.dispatch('GET_ARTICLE_COMMENTS', option)
    },

    //获取串联单信息
    getSortFormData (id) {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                        // 必须字段： 创建收藏记录参数
          "id": id,               // 必须字段： 文章 ID 
        }
      }
      this.$store.dispatch('GET_SORTFORM_INFODATA', option)

    },

    //获取新闻选题信息
    getNewsTopicData (id) {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                        // 必须字段： 创建收藏记录参数
          "type": "article",     // 必须字段： 类型，文章：article  素材： material
          "id": id,               // 必须字段： 文章 ID 或者 是素材 ID
        }
      }
      this.$store.dispatch('GET_NEWSTOPIC_INFODATA', option)
    },

    getHistoryRecordList (id) {
      this.$store.dispatch('GET_HISTORY_RECORD', id)
    },
    //获取关联素材
    getRelatedMatters (id) {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                        // 必须字段： 创建收藏记录参数
          "articleId": id,               // 必须字段： 文章 ID 或者 是素材 ID
        }
      }
      this.$store.dispatch('GET_RELATED_MATTER', option)
    },
    getLastFolderChoice () {
      var option = {
        ...this.$store.getters.baseOption,
        'params': {}
      }
      api._post(_IMGFILEURL_ + 'public/get_latest_folder_info', option).then((resp) => {
        if (resp.code == 200) {
          if (resp.data && resp.data.length > 0) {
            var folderId = resp.data[0].folderId
            var repoId = resp.data[0].repoId
            var path = resp.data[0].path
            var currentMatterFolder = {
              id_repo: repoId,
              id: folderId,
              currentFolderLocation: path
            }
            this.$root.eventHub.$emit('getCurrentMatterFolder', currentMatterFolder)
            this.$root.eventHub.$emit('getCurrentFolderModel', currentMatterFolder)
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
